import {BaseCachedService} from './Core/BaseCachedService';

class SurveyQuestionDataTypeService extends BaseCachedService {
    get Url() { return super.Url + "/surveyQuestionDataTypes"; }
    get ModelName() { return "Survey Question Data Type"; }
    get PrimaryKeyProperty() { return "surveyQuestionDataTypeId"; }
}

export const service = new SurveyQuestionDataTypeService();

